<script>
import Note from '@/components/shared/Note.vue';

export default {
  name: 'AppChecklist',

  components: {
    Note,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <ul class="checklist">
    <li v-for="note in content.notes" :key="note.sys.id" class="note">
      <Note :content="note.fields" type="checklist" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.checklist {
  list-style: none;
  background: $background-color-secondary;
  border-radius: $border-radius-xx-small;
  max-width: $text-block-width;
  padding: $space-8 $space-24;
}

@media print {
  a[href]:after {
    content: '';
  }
}
</style>
